import type { FC, SVGProps } from 'react';

import { LinkButton, type Props as LinkButtonProps } from './LinkButton';

type IconLinkButtonProps = Omit<LinkButtonProps, 'startIcon' | 'endIcon' | 'children' | 'isContentVisuallyHidden'> & {
  icon: FC<SVGProps<SVGSVGElement>>;
};

export function IconLinkButton({ icon, ...rest }: IconLinkButtonProps) {
  return <LinkButton {...rest} startIcon={icon} isContentVisuallyHidden />;
}
